import * as React from 'react'
import './ErrorPanel.scss'
import InvitationCodeExpired from '../../../assets/images/auth/invitation_code_expired.svg'

const InviteCodeExpired = () => {
  return (
    <div className='h-50 d-flex align-items-center'>
      <div className='auth-popup-container panel-width-480'>
        <div className='auth-popup-inner auth-popup-invitation-code-expired'>
          <div className='auth-popup-invitation-code-expired-logo'>
            <img src={InvitationCodeExpired} alt='Invitation link expired' />
          </div>
          <div className='auth-popup-content'>
            <span className='auth-popup-title'>Invitation link expired</span>
            <span className='auth-popup-text'>
              This invitation link is no longer active. The account owner or admins can send you a new one. Contact them to get back on track!
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InviteCodeExpired
